import React, { useState } from 'react';
import { Layout, RadioGroup as KRadioGroup, } from '@ui-kitten/components';
export const Kitten = (props) => {
    const [selectedIndex, setSelectedIndex] = useState(props.selectedIndex || 1);
    const { children, ...rest } = props;
    return (<Layout level="1">
      <KRadioGroup selectedIndex={selectedIndex} onChange={index => setSelectedIndex(index)} {...rest}>
        {children}
      </KRadioGroup>
    </Layout>);
};
export default {
    Kitten,
};
//# sourceMappingURL=RadioGroup.js.map